import { IcActivitiesLOutline } from "@frontend/ui-kit/icons/IcActivitiesLOutline";
import { IcActivitiesSOutline } from "@frontend/ui-kit/icons/IcActivitiesSOutline";
import { IcAnimalsLOutline } from "@frontend/ui-kit/icons/IcAnimalsLOutline";
import { IcAnimalsSOutline } from "@frontend/ui-kit/icons/IcAnimalsSOutline";
import { IcFlagsLOutline } from "@frontend/ui-kit/icons/IcFlagsLOutline";
import { IcFlagsSOutline } from "@frontend/ui-kit/icons/IcFlagsSOutline";
import { IcFoodLOutline } from "@frontend/ui-kit/icons/IcFoodLOutline";
import { IcFoodSOutline } from "@frontend/ui-kit/icons/IcFoodSOutline";
import { IcItemsLOutline } from "@frontend/ui-kit/icons/IcItemsLOutline";
import { IcItemsSOutline } from "@frontend/ui-kit/icons/IcItemsSOutline";
import { IcPeopleLOutline } from "@frontend/ui-kit/icons/IcPeopleLOutline";
import { IcPeopleSOutline } from "@frontend/ui-kit/icons/IcPeopleSOutline";
import { IcPlacesTravelLOutline } from "@frontend/ui-kit/icons/IcPlacesTravelLOutline";
import { IcPlacesTravelSOutline } from "@frontend/ui-kit/icons/IcPlacesTravelSOutline";
import { IcRecentLOutline } from "@frontend/ui-kit/icons/IcRecentLOutline";
import { IcRecentSOutline } from "@frontend/ui-kit/icons/IcRecentSOutline";
import { IcSymbolsLOutline } from "@frontend/ui-kit/icons/IcSymbolsLOutline";
import { IcSymbolsSOutline } from "@frontend/ui-kit/icons/IcSymbolsSOutline";
import type { EmojiCategoryType } from "../model";

export const EMOJI_GROUPS = [
    {
        static: true,
        label: "Часто используемые",
        iconS: <IcRecentSOutline />,
        iconM: <IcRecentLOutline />,
    },
    {
        label: "Смайлики и люди",
        iconS: <IcPeopleSOutline />,
        iconM: <IcPeopleLOutline />,
    },
    {
        label: "Животные и природа",
        iconS: <IcAnimalsSOutline />,
        iconM: <IcAnimalsLOutline />,
    },
    {
        label: "Еда и напитки",
        iconS: <IcFoodSOutline />,
        iconM: <IcFoodLOutline />,
    },
    {
        label: "Занятия",
        iconS: <IcActivitiesSOutline />,
        iconM: <IcActivitiesLOutline />,
    },
    {
        label: "Путешествия и места",
        iconS: <IcPlacesTravelSOutline />,
        iconM: <IcPlacesTravelLOutline />,
    },
    {
        label: "Предметы",
        iconS: <IcItemsSOutline />,
        iconM: <IcItemsLOutline />,
    },
    {
        label: "Символы",
        iconS: <IcSymbolsSOutline />,
        iconM: <IcSymbolsLOutline />,
    },
    {
        label: "Флаги",
        iconS: <IcFlagsSOutline />,
        iconM: <IcFlagsLOutline />,
    },
];

export const EMOJI_CATEGORY: Record<string, EmojiCategoryType> = {
    "1ee90645-cbde-64e7-9b51-54bfd56a660e": {
        id: "1ee90645-cbde-64e7-9b51-54bfd56a660e",
        nameLocal: "Животные и природа",
        order: 340,
    },
    "1ee90645-cbe0-6f26-9b51-e7620bd98fc6": {
        id: "1ee90645-cbe0-6f26-9b51-e7620bd98fc6",
        nameLocal: "Предметы",
        order: 900,
    },
    "1ee90645-cbe0-6bce-9b51-1efcf20994bf": {
        id: "1ee90645-cbe0-6bce-9b51-1efcf20994bf",
        nameLocal: "Занятия",
        order: 600,
    },
    "1ee90645-cbdf-6b27-9b51-284d26de4238": {
        id: "1ee90645-cbdf-6b27-9b51-284d26de4238",
        nameLocal: "Путешествия и места",
        order: 700,
    },
    "1ee90645-cbe2-6267-9b51-a2d4af958abc": {
        id: "1ee90645-cbe2-6267-9b51-a2d4af958abc",
        nameLocal: "Символы",
        order: 1090,
    },
    "1ee90645-c6b5-6435-9b51-53a0ade41140": {
        id: "1ee90645-c6b5-6435-9b51-53a0ade41140",
        nameLocal: "Смайлики и люди",
        order: 0,
    },
    "1ee90645-cbe3-64b6-9b51-2122d6121661": {
        id: "1ee90645-cbe3-64b6-9b51-2122d6121661",
        nameLocal: "Флаги",
        order: 1240,
    },
    "1ee90645-cbdf-6635-9b51-d6d3367d8c50": {
        id: "1ee90645-cbdf-6635-9b51-d6d3367d8c50",
        nameLocal: "Еда и напитки",
        order: 430,
    },
};

export const EMOJI_PANEL_LINE_HEIGHT = {
    s: 24,
    m: 28,
};

export const EMOJI_PANEL_TITLE_HEIGHT = {
    s: 20,
    m: 24,
};

export const EMOJI_PANEL_LIST_GAP = {
    s: 8,
    m: 12,
};
